module.exports = __webpack_public_path__ + "img/608241732fa1c.ba2bbf7f.png";